import React from 'react';
import { Table, Tooltip } from 'antd';
import dayjs from 'dayjs';

/**
 * Component to display a table of allocation history where column headers are timestamps and cell headers are labels
 * **Transposed data format from AllocationHistoryTable**
 * @param labels {Array<string>} - The labels for the columns
 * @param series {Array<Array<number>>} - The series of data to display
 * @param colorMapping {Object<string, string>} - Mapping of labels to colors
 * @returns {JSX.Element}
 * @constructor
 */
const TransposedHistoryTable = ({ labels, series, colorMapping }) => {
  // Generating new headers using timestamps
  const headers = [
    {
      title: 'Metric', // Label for the fixed column
      dataIndex: 'label',
      key: 'label',
      fixed: 'left',
      width: 100,  // Adjust width as needed for visibility
      className: 'fixed-column dark',
      render: text => (
        <div style={{
          backgroundColor: colorMapping[text.toLowerCase()],
          borderRadius: '4px',
          color: '#fff',
          padding: '8px',
          fontWeight: '300'
        }}>
          {text}
        </div>
      )

    },
    ...series.map(row => ({
      title: (
        <Tooltip title={dayjs(row[0]).format('MMMM YYYY')}>
          {dayjs(row[0]).format('MMM YY')}
        </Tooltip>
      ),
      dataIndex: row[0],
      key: row[0],
      className: 'tiny-header',
      width: 35,
      render: (text, record) => (
        <div style={{ color: '#000'}}>
          {text}
        </div>
      )
    }))
  ];
  // Creating rows from the labels and values in series
  const transposedData = labels.map((label, index) => {
    const newRow = { key: `label${index}`, label: label.toUpperCase() };
    series.forEach((row, rowIndex) => {
      newRow[row[0]] = row[index + 1] === 0 ? '' : `${row[index + 1].toFixed(1)}%`;
    });
    return newRow;
  });

  return (
    <Table
      columns={headers}
      dataSource={transposedData}
      pagination={false}
      scroll={{ x: 'max-content' }}
      size="small"
    />
  );
};

export default TransposedHistoryTable;
